import React, { FunctionComponent } from "react";
import styles from "./Image.module.scss";
import ImageProps from "./ImageProps.interface";

import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getImageCrop from "app/media/helpers/getImageCrop";
import ImageViewer from "components/ImageViewer/ImageViewer";
import combineClasses from "helpers/combine-classes";

const Image: FunctionComponent<ImageProps> = (props): JSX.Element => {
    const image = props.content.image;
    const imageCrop = getImageCrop(image?.umbracoFile.crops, props.mediaCrop, "Square (1:1)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, image?.umbracoWidth, image?.umbracoHeight);

    return (
        <div className={combineClasses(styles.wrapper, props.className)}>
            {image ? (
                <ImageViewer src={image.umbracoFile.src} focalPoint={image.umbracoFile.focalPoint} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
            ) : null}
        </div>
    );
};

export default Image;